"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
var browser_1 = require("@cian/config/browser");
var defaultSettings_1 = require("../../../shared/internal/Context/defaultSettings");
var Context = /** @class */ (function () {
    function Context(params) {
        this.userConfig = params.userConfig || {};
        this.model = params.model;
        this.globalCircuitBreakerHash = params.circuitBreakerHash;
        this.globalAssertStatusCode = params.assertStatusCode;
        this.requestedServerName = params.requestedServerName;
        this.cancellationToken = params.cancellationToken;
    }
    Object.defineProperty(Context.prototype, "failureTreshold", {
        get: function () {
            var _a;
            var failureTreshold = browser_1.getConfig().get('http.browser.circuitBreaker.failureTreshold') || 0.9;
            return ((_a = this.userConfig.circuitBreaker) === null || _a === void 0 ? void 0 : _a.failureTreshold) || failureTreshold;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "minimumSamples", {
        get: function () {
            var _a;
            var minimumSamples = browser_1.getConfig().get("http.browser.circuitBreaker.minimumSamples") || 9;
            return ((_a = this.userConfig.circuitBreaker) === null || _a === void 0 ? void 0 : _a.minimumSamples) || minimumSamples;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "maximumSamples", {
        get: function () {
            var _a;
            var maximumSamples = browser_1.getConfig().get("http.browser.circuitBreaker.maximumSamples") || 10;
            return ((_a = this.userConfig.circuitBreaker) === null || _a === void 0 ? void 0 : _a.maximumSamples) || maximumSamples;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "maxTimeForHalfOpenRequest", {
        get: function () {
            var _a;
            var maxTimeForHalfOpenRequest = browser_1.getConfig().get("http.browser.circuitBreaker.maxTimeForHalfOpenRequest") || 5000;
            return ((_a = this.userConfig.circuitBreaker) === null || _a === void 0 ? void 0 : _a.maxTimeForHalfOpenRequest) || maxTimeForHalfOpenRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "openDuration", {
        get: function () {
            var _a;
            var openDuration = browser_1.getConfig().get("http.browser.circuitBreaker.openDuration") || 5000;
            return ((_a = this.userConfig.circuitBreaker) === null || _a === void 0 ? void 0 : _a.openDuration) || openDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "samplingDuration", {
        get: function () {
            var _a;
            var samplingDuration = browser_1.getConfig().get("http.browser.circuitBreaker.samplingDuration") || 5000;
            return ((_a = this.userConfig.circuitBreaker) === null || _a === void 0 ? void 0 : _a.samplingDuration) || samplingDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "timeout", {
        get: function () {
            var timeout = this.userConfig.timeout || browser_1.getConfig().get("http.browser.timeout") || 10000;
            return timeout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "hashFunction", {
        get: function () {
            var _a;
            return ((_a = this.userConfig.circuitBreaker) === null || _a === void 0 ? void 0 : _a.hashFunction) || this.globalCircuitBreakerHash || defaultSettings_1.defaultCircuitBreakerHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "assertStatusCode", {
        get: function () {
            if (this.userConfig.assertStatusCode) {
                return this.userConfig.assertStatusCode;
            }
            if (this.model) {
                var forceGlobal = browser_1.getConfig().get('http.browser.assertStatusCode.forceGlobal');
                /**
                 * Это необходимо для обратной совместимости, если настройки в RS нет, то в старых мажорах
                 * приортет всегда отдавался глобальному ассерту.
                 */
                return forceGlobal === null || forceGlobal
                    ? this.globalAssertStatusCode || defaultSettings_1.defaultModelAssertStatusCode(this.model.assertStatusCodes)
                    : defaultSettings_1.defaultModelAssertStatusCode(this.model.assertStatusCodes);
            }
            return this.globalAssertStatusCode || defaultSettings_1.defaultAssertStatusCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "telemetryEnabled", {
        get: function () {
            var config = browser_1.getConfig();
            var isLocal = config.get('mcsRunEnv') === 'local';
            return config.get('http.browser.telemetry.enabled') || isLocal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "requestType", {
        get: function () {
            var requestType = browser_1.getConfig().get('http-api.browser.requestType');
            if (requestType === 'fetch' && window.fetch && window.AbortController) {
                return 'fetch';
            }
            return 'xhr';
        },
        enumerable: false,
        configurable: true
    });
    return Context;
}());
exports.Context = Context;
//# sourceMappingURL=Context.js.map